var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "white",
    opacity: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2.20595C18 0.988453 17.0115 0 15.7941 0H2.20595C0.988453 0 0 0.988453 0 2.20595V15.7941C0 17.0115 0.988453 18 2.20595 18H15.7941C17.0115 18 18 17.0115 18 15.7941V2.20595ZM9.96841 9.00007C9.96841 11.3709 8.05954 13.2928 5.70498 13.2928C3.35043 13.2928 1.44141 11.3709 1.44141 9.00007C1.44141 6.62927 3.35025 4.70725 5.70498 4.70725C8.05968 4.70725 9.96841 6.62927 9.96841 9.00007ZM14.6455 9.00007C14.6455 11.2316 13.6911 13.0415 12.5138 13.0415C11.3364 13.0415 10.382 11.2316 10.382 9.00007C10.382 6.76849 11.3362 4.95872 12.5136 4.95872C13.691 4.95872 14.6454 6.7679 14.6454 9.00007H14.6455ZM16.5586 9.00007C16.5586 10.999 16.223 12.6205 15.8089 12.6205C15.3947 12.6205 15.0592 10.9995 15.0592 9.00007C15.0592 7.00066 15.3949 5.37964 15.8089 5.37964C16.2228 5.37964 16.5586 7.00052 16.5586 9.00007Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.12c03531.svg";
export { ForwardRef as ReactComponent };